import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const options = {
    file_type: [
        { value: 'csv', label: 'Comma Separated Values (CSV)' },
        { value: 'txt', label: 'Tab-Delimited File (TXT)' },
        { value: 'json', label: 'JavaScript Object Notation (JSON)' }
    ],
    actions: [
        { value: 'POST', label: 'Add', icon: <AddIcon /> },
        { value: 'DELETE', label: 'Delete', icon: <ClearIcon /> },
        { value: 'PUT', label: 'Update', icon: <ArrowUpwardIcon /> }
    ],
    actionsGoogle: [
        { value: 'insert', label: 'Add', icon: <AddIcon /> },
        { value: 'delete', label: 'Delete', icon: <ClearIcon /> },
        { value: 'update', label: 'Update', icon: <ArrowUpwardIcon /> }
    ],
    qualtricsSurveyTypes: [
        { value: 'Student', label: 'Student' },
        { value: 'Staff', label: 'Staff' },
        { value: 'Other', label: 'Other' }
    ],
    noHeaders: [
        { value: true, label: 'True' }
    ],
    operator: [
        { value: 'lt', label: '<' },
        { value: 'le', label: '<=' },
        { value: 'eq', label: '=' },
        { value: 'ge', label: '>=' },
        { value: 'gt', label: '>' },
        { value: 'co', label: 'contains' }
    ],
    orientation: [
        { value: 'Portrait', label: 'Portrait'},
        { value: 'Landscape', label: 'Landscape'}
    ]
}

export default options;